<template>
  <div class="w-full h-full text-[20px] p-[20px] flex flex-col items-center">
    <h1 class="text-[30px] font-bold">{{ articleTitle }}</h1>
    <div class="w-full rich-content"
         v-html="articleData"></div>
    <div v-if="searchQuery"
         class="mt-[20px] text-center bg-osn-yellow-00 text-[15px] font-semibold leading-[40px] rounded-full cursor-pointer
            pc:w-[200px] mobile:w-full"
         @click="goSearchResult">
      {{ $t('article.go_to')}}
    </div>
  </div>
</template>
<script setup
        lang="ts">
import {useSearchQueryStore} from "~/stores/searchQuery";
import {useSearchWithStore} from "~/composables/useSearchWithStore";
import {useGoTo} from "~/composables/useGoTo";

const articleTitle = defineModel('title')
const articleData = defineModel('articleData')
const searchQuery = defineModel('searchQuery')
const searchQueryStore = useSearchQueryStore()
const {handleSearchWithStore} = useSearchWithStore()
const {go} = useGoTo();

function goSearchResult() {
  const searchJsonObj = JSON.parse(searchQuery.value)
  /// 清掉原本條件
  searchQueryStore.initQueryDate()
  searchQueryStore.setSelectedCityID(searchJsonObj.filter_options.city_ids)
  searchQueryStore.setSelectedCategoryObject(searchJsonObj.filter_options.category_ids)
  /// 搜尋
  handleSearchWithStore()
  /// go
  go('/search-result')
}
</script>
<style lang="scss">
.rich-content {
  table {
    border-collapse: collapse;
    width: 100%;
    border: 1px solid black;
  }

  th, td {
    border: 1px solid black;
    padding: 8px;
  }
}


</style>
